import { render, staticRenderFns } from "./PlanejamentoDpmGrupoCulturasPainel.vue?vue&type=template&id=52c09b64&scoped=true&"
import script from "./PlanejamentoDpmGrupoCulturasPainel.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoDpmGrupoCulturasPainel.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoDpmGrupoCulturasPainel.vue?vue&type=style&index=0&id=52c09b64&scoped=true&lang=css&"
import style1 from "./PlanejamentoDpmGrupoCulturasPainel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c09b64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCol,VContainer,VDataTable,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VIcon,VMenu,VRow,VTextField})
